import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { DataAccessScreensizeFacade, DataAccessScreensizeModule } from '@planone/bau365/data-access-screensize';
/* eslint @nrwl/nx/enforce-module-boundaries: 0 */
import { Bau365DataAccessSearchModule } from '@planone/bau365/data-access-search';
import { SharedUtilFeatureFlagsModule } from '@planone/shared/data-access-feature-flags';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUtilMetaModule } from '@planone/shared/util-meta';

import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LayoutComponent } from './layout/layout.component';
import { LogoDarkComponent } from './logo-dark/logo-dark.component';
import { MobileBottomBarComponent } from './mobile-bottom-bar/mobile-bottom-bar.component';
import { MobileLayerHeaderComponent } from './mobile-layer-header/mobile-layer-header.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PageServiceUnavailableComponent } from './page-service-unavailable/page-service-unavailable.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    SharedUiElementsModule,
    DataAccessScreensizeModule,
    MatMenuModule,
    SharedUtilMetaModule,
    SharedUtilFeatureFlagsModule,
    Bau365DataAccessSearchModule,
    SharedUtilPipelinesModule,
  ],
  declarations: [
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    LogoDarkComponent,
    PageNotFoundComponent,
    PageServiceUnavailableComponent,
    MobileLayerHeaderComponent,
    MobileBottomBarComponent,
  ],
  exports: [LayoutComponent, LogoDarkComponent, PageNotFoundComponent, PageServiceUnavailableComponent],
  providers: [DataAccessScreensizeFacade],
})
export class Bau365UiShellModule {}
